module.exports = __webpack_public_path__ + "static/media/m_w_hw_25.3c5b964a.png";